import NumberInput from './NumberInput';

interface PercentInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  helperText?: string;
}

export default function PercentInput({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  helperText,
}: PercentInputProps) {
  return (
    <NumberInput
      label={label}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      suffix="%"
      helperText={helperText}
    />
  );
}
